import React from 'react';
import styles from './pessoa-selecionada.module.scss';

const PessoaSelecionada = ({pessoa, exibeTipoPessoa=false}) => {
    if(!pessoa || pessoa === null){
        return <></>;
    }

    let tipoPessoa = "";
    if(exibeTipoPessoa){
        tipoPessoa = (<span className={styles.tipo}>
            {pessoa.tipoPessoa}
        </span>);
    }

    return (
        <div className={styles.pessoaWrapper}>
            {tipoPessoa}
            <span className={styles.nome}>
                {(pessoa.nome || 'N/D')}
            </span>
            <span className={styles.cpfCnpj}>
               CPF/CNPJ: {(pessoa.cpfCnpj || 'N/D')}
            </span>
                
        </div>
    );
};

export {PessoaSelecionada};